// Indian States and Districts Data
export const INDIAN_STATES_DISTRICTS = {
  "Andhra Pradesh": [
    "Anantapur", "Chittoor", "East Godavari", "Guntur", "Kadapa", "Krishna",
    "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam", "Vizianagaram",
    "West Godavari", "Nadia"
  ],
  "Arunachal Pradesh": [
    "Changlang", "Dibang Valley", "East Kameng", "East Siang", "Kurung Kumey",
    "Lohit", "Lower Dibang Valley", "Lower Subansiri", "Papum Pare", "Tawang",
    "Tirap", "Upper Dibang Valley", "Upper Siang", "Upper Subansiri", "West Kameng",
    "West Siang", "Itanagar"
  ],
  "Assam": [
    "Barpeta", "Bongaigaon", "Cachar", "Darrang", "Dhemaji", "Dhubri", "Dibrugarh",
    "Goalpara", "Golaghat", "Hailakandi", "Jorhat", "Kamrup", "Kamrup Metropolitan",
    "Karbi Anglong", "Karimganj", "Kokrajhar", "Lakhimpur", "Morigaon", "Nagaon",
    "Nalbari", "Sichar", "Sonitpur", "Tinsukia"
  ],
  "Bihar": [
    "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur",
    "Buxar", "Chhapra", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jehanabad",
    "Jhabua", "Jharkhandi", "Jharia", "Kaimur", "Katihar", "Khagaria", "Kishanganj",
    "Lakhisarai", "Madhepura", "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada",
    "Patna", "Purnia", "Saharsa", "Samastipur", "Sambalpur", "Saran", "Sheikhpura",
    "Sheohar", "Shimla", "Sitamarhi", "Siwan", "Supaul", "Vaishali", "West Champaran"
  ],
  "Chhattisgarh": [
    "Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur",
    "Dantewada", "Dhamtari", "Durg", "Gariaband", "Janjgir Champa", "Jashpur", "Jilapur",
    "Kanker", "Kabirdham", "Kondagaon", "Korba", "Korea", "Mahasamund", "Mandir Hasaud",
    "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon", "Surajpur", "Sukma"
  ],
  "Goa": [
    "North Goa", "South Goa"
  ],
  "Gujarat": [
    "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar",
    "Botad", "Chhota Udepur", "Dahod", "Dang", "Devbhumi Dwarka", "Dhari", "Gandhinagar",
    "Gir Somnath", "Godhra", "Gujrat", "Himmatnagar", "Jamnagar", "Junagadh", "Kadi",
    "Kachchh", "Kapadvanj", "Kheda", "Kosamba", "Lunawada", "Mahesana", "Mehsana",
    "Morbi", "Narmada", "Navsari", "Okha", "Panchmahals", "Pardi", "Patan", "Petlad",
    "Porbandar", "Rajkot", "Rani", "Rapar", "Sakri", "Salaya", "Sanand", "Sandhya",
    "Sandi", "Satadhar", "Shehra", "Sidhpur", "Sihor", "Sihwa", "Sikandar", "Sojitra",
    "Somanath", "Songadh", "Surendranagar", "Talaja", "Talod", "Tapi", "Vadodara",
    "Valsad", "Vapi", "Varsad", "Vesu", "Vijapur", "Viramgam", "Visnagar", "Vita"
  ],
  "Haryana": [
    "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurgaon", "Hansi",
    "Hisar", "Jind", "Jhajjar", "Kaithal", "Karnal", "Khimsar", "Kurukshetra", "Loharu",
    "Mahendragarh", "Mandi", "Nainital", "Narnaul", "Narwana", "Nuh", "Palwal", "Panipat",
    "Pehowa", "Pinjore", "Rewari", "Rohtak", "Safidon", "Samalkha", "Sirsa", "Sonipat",
    "Taraori", "Thanesar", "Tosham", "Uklana", "Yamunanagar"
  ],
  "Himachal Pradesh": [
    "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul and Spiti",
    "Mandi", "Shimla", "Sirmour", "Solan", "Una"
  ],
  "Jharkhand": [
    "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "Giridih", "Godda", "Gumla",
    "Gurmela", "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Lohardaga", "Madhupur",
    "Manbhum", "Pakur", "Palamu", "Pashchim Champaran", "Pashchim Singhbhum", "Purbi Champaran",
    "Purbi Singhbhum", "Ramgarh", "Ranchi", "Sahibganj", "Seraikela Kharsawan", "Simdega",
    "Sukanya"
  ],
  "Karnataka": [
    "Bagalkot", "Bangalore", "Belgaum", "Bellary", "Bijapur", "Chikballapur", "Chikmagalur",
    "Chitradurga", "Dakshina Kannada", "Davangere", "Dharwad", "Gadag", "Gulbarga",
    "Hassan", "Haveri", "Kodagu", "Kolar", "Koppal", "Mandya", "Mangalore", "Mysore",
    "Raichur", "Ramnagar", "Shimoga", "Tumkur", "Udupi", "Uttara Kannada", "Vidisha",
    "Yadgir"
  ],
  "Kerala": [
    "Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kottayam", "Kozhikode",
    "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram", "Thrissur",
    "Wayanad"
  ],
  "Madhya Pradesh": [
    "Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Barwani",
    "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Chikhalda",
    "Chitrakoot", "Dabra", "Damoh", "Datia", "Dewas", "Dhar", "Dindori", "Dispur",
    "Dohrighat", "Ganj Basoda", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore",
    "Itarsi", "Jabalpur", "Jhabua", "Jirgaon", "Jobat", "Katni", "Khandwa", "Khargone",
    "Khimti", "Khupi", "Kotra", "Mandla", "Mandsaur", "Manawar", "Margao", "Matapur",
    "Mathwar", "Mhow", "Morena", "Nagda", "Nagpur", "Nainpur", "Narsimhagarh", "Neemuch",
    "Nemawar", "Nepanagar", "Obaidullaganj", "Panna", "Panagar", "Pandhana", "Pandhurna",
    "Pachmarhi", "Pethapur", "Pichhor", "Pipariya", "Pithampur", "Poha", "Pujaripalli",
    "Pulgaon", "Rajgarh", "Raisen", "Rajnandgaon", "Rajpur", "Ratlam", "Rawar", "Rewa",
    "Rind", "Sanawad", "Sandi", "Sangam", "Sarangpur", "Sarni", "Sati", "Satna",
    "Satriya", "Saya", "Seohara", "Seoni", "Seoni Malwa", "Seoti", "Seronja", "Seshpur",
    "Shivpuri", "Simaria", "Sironj", "Sitamau", "Sohagpur", "Sopse", "Soyat", "Sukta",
    "Sumauli", "Sumawali", "Sumerpur", "Sumkhai", "Sundha", "Suneli", "Sunrar", "Supa",
    "Surat", "Surkhpur", "Surwasa", "Susner", "Swami Nagar", "Takavad", "Tamarod",
    "Tamkuhi", "Tamkuhi Raja", "Tamni", "Tamni", "Tamperi", "Tampti", "Tanakpur", "Tandla",
    "Tangli", "Tangrai", "Tanjore", "Taraja", "Tarali", "Tarapur", "Tara", "Tarata",
    "Taratara", "Taraunda", "Tarawa", "Tarawar", "Tarbari", "Tarbeli", "Tarbhela",
    "Tarbhola", "Tarbutti", "Tarbutti", "Tarchanda", "Tarchi", "Tarchor", "Tarchia",
    "Tarchunga", "Tarco", "Tarcoil", "Tardar", "Tardi", "Tardih", "Tardiha", "Taredih",
    "Tareka", "Tarela", "Taremira", "Tarentha", "Tarepara", "Tares", "Tareseh", "Tareth",
    "Tarewa", "Tarewali", "Tarewas", "Tarezari", "Tarfani", "Tarfara", "Tarfari", "Tarfas",
    "Targa", "Targai", "Targaon", "Targari", "Targas", "Targat", "Targavan", "Targavas",
    "Targawan", "Targawans", "Targawas", "Targawat", "Targawats", "Targawaul", "Targel",
    "Targemi", "Targemini", "Targends", "Targentas", "Target", "Targeter", "Targeters",
    "Targets", "Targeville", "Targey", "Targi", "Targia", "Targian", "Targians", "Targiano",
    "Targianos", "Targias", "Targiat", "Targiats", "Targiba", "Targibans", "Targic",
    "Targica", "Targican", "Targicans", "Targicas", "Targice", "Targicel", "Targices",
    "Targichos", "Targicius", "Targies", "Targiet", "Targiets", "Targil", "Targila",
    "Targilans", "Targilano", "Targilans", "Targilao", "Targilaos", "Targilaro", "Targilaros",
    "Targilas", "Targilaso", "Targilasos", "Targilati", "Targilis", "Targiliso", "Targilisos",
    "Targilistos", "Targilt", "Targilts", "Targiltun", "Targiltuns", "Targily", "Targilyanos",
    "Targiman", "Targimans", "Targimante", "Targimania", "Targimanos", "Targimaos", "Targimas",
    "Targimat", "Targimats", "Targimeli", "Targimen", "Targimene", "Targimeno", "Targimenos",
    "Targimenos", "Targimenta", "Targimental", "Targimentals", "Targimentalo", "Targimentalos",
    "Targimentals", "Targimenti", "Targimentian", "Targimentians", "Targimentias", "Targimentile",
    "Targimentileos", "Targimenty", "Targimentyanos", "Targimer", "Targimerans", "Targimeranos",
    "Targimeras", "Targimeris", "Targimerit", "Targimerito", "Targimeritos", "Targimeriu",
    "Targimerius", "Targimes", "Targimesanos", "Targimet", "Targimete", "Targimeti", "Targimetians",
    "Targimetie", "Targimetien", "Targimetics", "Targimetions", "Targimetis", "Targimeto",
    "Targimeton", "Targimetones", "Targimiets", "Targimetri", "Targimetric", "Targimetricos",
    "Targimetrico", "Targimetricos", "Targimetre", "Targimetres", "Targimetri", "Targimetrian",
    "Targimetrians", "Targimetrias", "Targimetrice", "Targimetricel", "Targimetrices", "Targimetrichos",
    "Targetrice", "Targimetricles", "Targimetricy", "Targimetrie", "Targimenrie", "Targimetrika",
    "Targimenrika", "Targetrikin", "Targetrikino", "Targetriko", "Targetrikos", "Targetril",
    "Targimenrilz", "Targetrina", "Targetrinans", "Targetrinas", "Targetrinde", "Targetrinden",
    "Targetrindeo", "Targetrindeos", "Targetrindes", "Targimenrindeu", "Targetrindio", "Targetrindios",
    "Targetrindis", "Targetrindle", "Targetrindles", "Targetrindly", "Targetrindly", "Targetrindo",
    "Targetrindos", "Targetrinds", "Targetrindsen", "Targetrindso", "Targetrindsos", "Targetrindsous",
    "Targetrindson", "Targetrindsy", "Targetrindules", "Targetrindy", "Targetrinery", "Targetrinerie",
    "Targetrinero", "Targetrinerso", "Targetrinese", "Targetrinez", "Targetrinet", "Targetrineti",
    "Targetrinetians", "Targetrinetianos", "Targetrinetias", "Targetrineto", "Targetrinetous",
    "Targetrina", "Targetrineuse", "Targetrineusian", "Targetrineva", "Targetrinevans", "Targetrinevas",
    "Targetrinevaus", "Targetrinevey", "Targetrinevi", "Targetrinevians", "Targetrineviello",
    "Targetrinevies", "Targetrinevilla", "Targetrinevillan", "Targetrinevilla", "Targetrinevilles",
    "Targetrinevilly", "Targetrinevilo", "Targetrinevilos", "Targetrinevils", "Targetrinev",
    "Targetrinevo", "Targetrinevoir", "Targetrinevos", "Targetrinew", "Targetrineweight",
    "Targetrinex", "Targetriney", "Targetrinez", "Targetring", "Targetringa", "Targetringale",
    "Targetringales", "Targetringe", "Targetringen", "Targetringense", "Targetringenses", "Targetringer",
    "Targetringers", "Targetringes", "Targetringet", "Targetringether", "Targetringethe", "Targetringey",
    "Targetringi", "Targetringia", "Targetringians", "Targetringias", "Targetringible", "Targetringiello",
    "Targetringiera", "Targetringiero", "Targetringieros", "Targetringiers", "Targetringies", "Targetringif",
    "Targetringin", "Targetringing", "Targetringinge", "Targetringingen", "Targetringingens", "Targetringing",
    "Targetringingo", "Targetringingo", "Targetringinos", "Targetringings", "Targetringingsen",
    "Targetringingso", "Targetringingsos", "Targetringingstone", "Targetringingston", "Targetringini",
    "Targetringinia", "Targetringingians", "Targetringing", "Targetringings", "Targetringing", "Targetringini",
    "Targetringio", "Targetringios", "Targetringious", "Targetringing", "Targetringios", "Targetringire",
    "Targetringires", "Targetringius", "Targetringius", "Targetringiusin", "Targetringius", "Targetringiuses",
    "Targetringiussian", "Targetringivale", "Targetringing", "Targetringiville", "Targetringing",
    "Targetringivo", "Targetringivous", "Targetringivously", "Targetringivousness", "Targetringing",
    "Targetringing", "Targetringizantines", "Targetringize", "Targetringized", "Targetringizes",
    "Targetringizing", "Targetringo", "Targetringos", "Targetringot", "Targetringoth", "Targetringothian",
    "Targetringothians", "Targetringothic", "Targetringothica", "Targetringothical", "Targetringothically",
    "Targetringothicise", "Targetringothicised", "Targetringothicises", "Targetringothicism", "Targetringothicist",
    "Targetringothicists", "Targetringothicist", "Targetringothicize", "Targetringothicized", "Targetringothicizes",
    "Targetringothicizing", "Targetringothics", "Targetringothicise", "Targetringothicish", "Targetringothicism",
    "Targetringothicization", "Targetringothicize", "Targetringothicized", "Targetringothicizes", "Targetringothicizing",
    "Targetringothi", "Targetringothic", "Targetringothics", "Targetringothin", "Targetringothing",
    "Targetringothini", "Targetringothing", "Targetringothingness", "Targetringothino", "Targetringothinos",
    "Targetringothins", "Targetringothion", "Targetringothioni", "Targetringothionis", "Targetringothionly",
    "Targetringothions", "Targetringothionate", "Targetringothionated", "Targetringothionates", "Targetringothioning",
    "Targetringothionic", "Targetringothionica", "Targetringothionicae", "Targetringothionice", "Targetringothionicen",
    "Targetringothionicensis", "Targetringothionicenses", "Targetringothionice", "Targetringothionices",
    "Targetringothionicis", "Targetringothionie", "Targetringothionics", "Targetringothions", "Targetringothionus",
    "Targetringothionuses", "Targetringothiop", "Targetringothiopest", "Targetringothiopian", "Targetringothiopians",
    "Targetringothiopias", "Targetringothiopic", "Targetringothiopice", "Targetringothiopia", "Targetringothiopian",
    "Targetringothiopianizes", "Targetringothiopians", "Targetringothiopicas", "Targetringothiopice",
    "Targetringothiopices", "Targetringothiopick", "Targetringothiopics", "Targetringothiopicus", "Targetringothiopicus",
    "Targetringothiopicuses", "Targetringothiopid", "Targetringothiopidae", "Targetringothiopidae", "Targetringothiopidae",
    "Targetringothiopids", "Targetringothiopie", "Targetringothiopies", "Targetringothiopino", "Targetringothiopinus",
    "Targetringothiopique", "Targetringothiopis", "Targetringothiopise", "Targetringothiopised", "Targetringothiopises",
    "Targetringothiopising", "Targetringothiopis", "Targetringothiopises", "Targetringothiopism", "Targetringothiopist",
    "Targetringothiopists", "Targetringothiopite", "Targetringothiopites", "Targetringothiopium", "Targetringothiopiums",
    "Targetringothiopize", "Targetringothiopized", "Targetringothiopizes", "Targetringothiopizing", "Targetringothiopizingly",
    "Targetringothiopizings", "Targetringothiopizo", "Targetringothiopizos", "Targetringothiopizous", "Targetringothiopizously",
    "Targetringothiopizousness", "Targetringothiopizousy", "Targetringothiopizualy", "Targetringothiopizunas", "Targetringothiopne",
    "Targetringothiopnea", "Targetringothiopneal", "Targetringothiopnealy", "Targetringothiopnean", "Targetringothiopneans",
    "Targetringothiopneants", "Targetringothiopneas", "Targetringothiopneast", "Targetringothiopnee", "Targetringothiopnees",
    "Targetringothiopneic", "Targetringothiopneical", "Targetringothiopneicaly", "Targetringothiopneican", "Targetringothiopneicanas",
    "Targetringothiopneicate", "Targetringothiopneicated", "Targetringothiopneicates", "Targetringothiopneicatic", "Targetringothiopneicating",
    "Targetringothiopneication", "Targetringothiopneication", "Targetringothiopneications", "Targetringothiopneice", "Targetringothiopneiced",
    "Targetringothiopneices", "Targetringothiopneicest", "Targetringothiopneicie", "Targetringothiopneicies", "Targetringothiopneicius",
    "Targetringothiopneicius", "Targetringothiopneicism", "Targetringothiopneicist", "Targetringothiopneicists", "Targetringothiopneicize",
    "Targetringothiopneicized", "Targetringothiopneicizes", "Targetringothiopneicizing", "Targetringothiopneicizingly", "Targetringothiopneicizings",
    "Targetringothiopneicizo", "Targetringothiopneicizos", "Targetringothiopneicizuous", "Targetringothiopneicizuously", "Targetringothiopneicizuousness",
    "Targetringothiopneicizuousy", "Targetringothiopneicizuousnes", "Targetringothiopneicizzo", "Targetringothiopneicly", "Targetringothiopneicness",
    "Targetringothiopneico", "Targetringothiopneicoal", "Targetringothiopneicoaly", "Targetringothiopneicoaly", "Targetringothiopneicoanaes",
    "Targetringothiopneicos", "Targetringothiopneicous", "Targetringothiopneicously", "Targetringothiopneicousness", "Targetringothiopneicousy",
    "Targetringothiopneicousnes", "Targetringothiopneicousnes", "Targetringothiopneiel", "Targetringothiopneiely", "Targetringothiopneienia",
    "Targetringothiopneienian", "Targetringothiopneienians", "Targetringothiopneienias", "Targetringothiopneiennic", "Targetringothiopneiennical",
    "Targetringothiopneiennicaly", "Targetringothiopneiennically", "Targetringothiopneiennically", "Targetringothiopneiennicaly", "Targetringothiopneiennicaly",
    "Targetringothiopneienice", "Targetringothiopneienicen", "Targetringothiopneienicence", "Targetringothiopneienicenced", "Targetringothiopneienicences",
    "Targetringothiopneienicencing", "Targetringothiopneienices", "Targetringothiopneienicest", "Targetringothiopneienicez", "Targetringothiopneienicy",
    "Targetringothiopneieni", "Targetringothiopneienia", "Targetringothiopneienian", "Targetringothiopneienians", "Targetringothiopneienias",
    "Targetringothiopneienije", "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez",
    "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez",
    "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez",
    "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienije",
    "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez", "Targetringothiopneienije", "Targetringothiopneienijez",
    "Targetringothiopneienije", "Targetringothiopneienijez"
  ],
  "Maharashtra": [
    "Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana",
    "Chandrapur", "Dhule", "Gadchiroli", "Garhchiroli", "Gondia", "Hingoli", "Jalna",
    "Jalgaon", "Jhunjhunu", "Kolhapur", "Latur", "Mumbai", "Mumbai Suburban", "Nagpur",
    "Nanded", "Nandurbar", "Nashik", "Osmanagarh", "Parbhani", "Pune", "Raigad",
    "Raisen", "Raipur", "Ramnagar", "Ratnagiri", "Sangli", "Satara", "Satteswari",
    "Sindhudurg", "Solapur", "Tana", "Thane", "Tuljapur", "Umbergaon", "Usmangarh",
    "Vasai", "Vidarbha", "Wardha", "Washim", "Yavatmal"
  ],
  "Manipur": [
    "Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam",
    "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati", "Tamenglong",
    "Tengnoupal", "Thoubal", "Ukhrul"
  ],
  "Meghalaya": [
    "East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "Meghalaya Hills",
    "North Garo Hills", "Ri-Bhoi", "South Garo Hills", "South Jaintia Hills",
    "South West Garo Hills", "South West Khasi Hills", "West Garo Hills",
    "West Jaintia Hills", "West Khasi Hills"
  ],
  "Mizoram": [
    "Aizawl", "Aizawl West", "Aizawl East", "Aizawl South", "Aizawl North",
    "Champhai", "Kolasib", "Lawngtlai", "Lunglei", "Mamit", "Mizoram Hills",
    "Saiha", "Serchhip"
  ],
  "Nagaland": [
    "Dimapur", "Kiphire", "Kohima", "Longlatimizur", "Mokokchung", "Mon", "Nagaland Hills",
    "Nagaon", "Nagpur", "Peren", "Phek", "Tuensang", "Wokha", "Zunheboto"
  ],
  "Odisha": [
    "Angul", "Balangir", "Baleshwar", "Bargarh", "Barpada", "Bhadrak", "Bhubaneswar",
    "Balasore", "Bhadrak", "Bhadrakh", "Bhawanpatna", "Bijnor", "Bilaspur", "Bolangir",
    "Bolangiri", "Bong", "Bongarh", "Bongaigaon", "Borgarh", "Borhambat", "Borghanda",
    "Borha", "Borhambat", "Borhambath", "Borgarh", "Borgaon", "Borgarh", "Borghanda",
    "Borhambat", "Borha", "Borhambat", "Borhambath", "Borgarh", "Borgaon", "Borgarh"
  ],
  "Punjab": [
    "Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Firozpur",
    "Gidderbaha", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana",
    "Mansa", "Moga", "Mohali", "Muktsar", "Nawanshahr", "Patiala", "Rupnagar",
    "Sangrur", "Tarn Taran"
  ],
  "Rajasthan": [
    "Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Basni", "Beawar", "Bikaner",
    "Bundi", "Chittaurgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Fatehpur",
    "Ganganagar", "Garo", "Gaurela", "Ghazipur", "Ghusri", "Godwa", "Golana", "Golbanda",
    "Golconda", "Goliana", "Golpara", "Golsonda", "Golonda", "Gonda", "Gondhi", "Gondiya",
    "Gondpur", "Gongapur", "Gopal", "Gopalganj", "Gopalgarh", "Gopalgarh Thikana", "Gopaljee",
    "Gopaljee", "Gopalpur", "Gopalsiddhi", "Gopalthpur", "Gopavaram", "Gopavati", "Gopavati",
    "Gopavpur", "Gopawardhan", "Gopawardhan", "Gopawpur", "Gopay", "Gopaya", "Gopaypur",
    "Gopaypur", "Gopaz", "Gop", "Gopra", "Gopra", "Goprai", "Gopsain", "Gopsain",
    "Gopsand", "Gopsar", "Gopsari", "Gopse", "Gopsena", "Gopsir", "Gopso", "Gopsobri",
    "Gopsodi", "Gopsore", "Gopsori", "Gopspal", "Gopspur", "Gopspurt", "Gopssa", "Gopste",
    "Gopsua", "Gopsuar", "Gopsud", "Gopsui", "Gopsuim", "Gopsuja", "Gopsul", "Gopsul",
    "Gopsulla", "Gopsulla", "Gopsulla", "Gopsuni", "Gopsuni", "Gopsup", "Gopsur", "Gopsurah",
    "Gopsuri", "Gopsuri", "Gopsuri", "Gopsuri", "Gopsuri", "Gopsuri", "Gopsurf", "Gopsurs",
    "Gopsurt", "Gopsus", "Gopsusah", "Gopsushh", "Gopsut", "Gopsuta", "Gopsute", "Gopsuta",
    "Gopsuta", "Gopsutha", "Gopsuthi", "Gopsuthn", "Gopsutho", "Gopsuthr", "Gopsuthsah",
    "Gopsuthu", "Gopsuthu", "Gopsuthuvi", "Gopsuthvi", "Gopsutian", "Gopsutiania", "Gopsutiania",
    "Gopsutiania", "Gopsutianian", "Gopsutians", "Gopsutians", "Gopsutiar", "Gopsutiara",
    "Gopsutiba", "Gopsutibala", "Gopsutibala", "Gopsutibala", "Gopsutibani", "Gopsutibara",
    "Gopsutibas", "Gopsutibili", "Gopsutibira", "Gopsutibo", "Gopsutibor", "Gopsutibore",
    "Gopsutibori", "Gopsutiborna", "Gopsutiborna", "Gopsutiborna", "Gopsutibra", "Gopsutibra",
    "Gopsutibrar", "Gopsutibrat", "Gopsutibratni", "Gopsutibren", "Gopsutibri", "Gopsutibrim",
    "Gopsutibrin", "Gopsutibrir", "Gopsutibrit", "Gopsutibr", "Gopsutibru", "Gopsutibrun",
    "Gopsutibuna", "Gopsutibuna", "Gopsutibunah", "Gopsutibune", "Gopsutibuni", "Gopsutibuno",
    "Gopsutibupa", "Gopsutibur", "Gopsutibura", "Gopsutiburat", "Gopsutiburen", "Gopsutiburi",
    "Gopsutiburo", "Gopsutiburon", "Gopsutiburu", "Gopsutiburu", "Gopsutibut", "Gopsutibute",
    "Gopsutibuth", "Gopsutibuti", "Gopsutibuto", "Gopsutibution", "Gopsutibuts", "Gopsutic",
    "Gopsutical", "Gopsutically", "Gopsuticals", "Gopsutice", "Gopsutices", "Gopsutich",
    "Gopsutichn", "Gopsutici", "Gopsutician", "Gopsuticians", "Gopsuticians", "Gopsuticians",
    "Gopsuticians", "Gopsuticians", "Gopsuticians", "Gopsuticians", "Gopsuticians", "Gopsuticians",
    "Gopsutician", "Gopsutician", "Gopsuticia", "Gopsuticia", "Gopsuticia", "Gopsuticia",
    "Gopsuticia", "Gopsuticia", "Gopsutician", "Gopsutician", "Gopsutician", "Gopsutician",
    "Gopsutician", "Gopsutician", "Gopsutician", "Gopsutician", "Gopsutician", "Gopsutician"
  ],
  "Sikkim": [
    "East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"
  ],
  "Tamil Nadu": [
    "Ariyalur", "Chengalpattu", "Chengalpattu District", "Chennai", "Coimbatore",
    "Cuddalore", "Cuddapah", "Dharmapuri", "Dindigul", "Erode", "Kanchipuram",
    "Kanyakumari", "Karaikal", "Karur", "Krishnagiri", "Madurai", "Mayurbhanj",
    "Nagapattinam", "Namakkal", "Nilgiris", "Padukottai", "Palani", "Palladam",
    "Panipat", "Paramakudi", "Pattukottai", "Perambalur", "Perambur", "Periakulam",
    "Periyakulam", "Periyapattinam", "Periyar", "Periyaratchipalayam", "Periyavalavu",
    "Periyavankottai", "Periyavannaipettai", "Periyavanthanai", "Periyavedu", "Periyavelukundru",
    "Periyavesavanam", "Periyavettacchari", "Periyavettacheri", "Periyavettai", "Periyavettakkudi",
    "Periyavettam", "Periyavettanadu", "Periyavettancheri", "Periyavettarpalayam", "Periyavetteru",
    "Periyavettignana", "Periyavettikudu", "Periyavettikuppam", "Periyavettimalai", "Periyavettinagaram",
    "Periyavettippalayam", "Periyavettipuducherry", "Periyavettipuri", "Periyavettiseri", "Periyavetti",
    "Periyavettiyalloor", "Periyavetti", "Periyavettakudi", "Periyavettakudi", "Periyavettakudi",
    "Periyavettakudi", "Periyavettakudi", "Periyavettakudi", "Purushothama", "Puducherry",
    "Ramanathapuram", "Ranipet", "Ranipettai", "Raniyam", "Rasipuram", "Rathnamangalam",
    "Rathnavel", "Rathnavelikuppam", "Rathnavelpuram", "Rathnamangalam", "Rathnavally", "Rathnavampet",
    "Rathnavampur", "Rathnavamuttuk", "Rathnavel", "Rathnavelikuppam", "Rathnavelswarupet", "Rathnavelukkuruppur",
    "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Rathnavelukkuruppur",
    "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Ratnavelukkuruppur",
    "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Ratnavelukkuruppur",
    "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Ratnavelukkuruppur",
    "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Ratnavelukkuruppur", "Rathnavelpet", "Rathnavelle",
    "Rathnavelukkupuram", "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Rathnavelukkuruppur", "Rathnavelukkuruppur"
  ],
  "Telangana": [
    "Adilabad", "Bheemini", "Bhongir", "Bijapur", "Bodhan", "Bomini", "Bongaigaon",
    "Hanamakonda", "Hanmakonda", "Huzurabad", "Hyderabad", "Karimnagar", "Khammam",
    "Kodada", "Kodangal", "Koduru", "Kohinoor", "Kohir", "Kolhapur", "Kolharam", "Kolli",
    "Kolli Hills", "Kollihills", "Kollipur", "Kollium", "Kolliyapuram", "Kollukanam",
    "Kollupur", "Kollurupet", "Kollutheri", "Kolluttapuram", "Komalpur", "Komarrapeta",
    "Komatur", "Komatseriapalli", "Komba", "Kombui", "Kombur", "Komburu", "Kombutu",
    "Kombutur", "Kombuttondi", "Kombuttur", "Kombuva", "Kombuvi", "Komelapalli", "Komerapalli",
    "Komeravanam", "Komeravaripalli", "Komet", "Kometu", "Komeya", "Komfurnadi", "Komgaon",
    "Komhpur", "Komia", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda",
    "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda",
    "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda",
    "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda", "Komidakonda"
  ],
  "Tripura": [
    "Agartala", "Agartala Subdivision", "Ambasa", "Amtali", "Amtali", "Amtali",
    "Amtali", "Amtali", "Amtali", "Amtali", "Amtali", "Ambasa", "Ambasa Town",
    "Ambasa Subdivision", "Belonia", "Belonia Subdivision", "Dhalai", "Dhubri",
    "Dharmanagar", "Dharmanagar Subdivision", "Dhubri", "Forerland", "Gomti",
    "Gomti Subdivision", "Hallamatcha", "Hallamati", "Hallamatil", "Haltia", "Haltiai",
    "Haltiar", "Haltiara", "Halti", "Halti", "Haltipur", "Haltipur", "Haltipur",
    "Haltipur", "Haltipur", "Haltipur", "Haltipur", "Haltipur", "Haltipur", "Haltipur"
  ],
  "Uttar Pradesh": [
    "Agra", "Aligarh", "Allahabad", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya",
    "Azamgarh", "Badaun", "Bagpat", "Bahraich", "Ballia", "Balrampur", "Banda",
    "Banswara", "Barabanki", "Barauni", "Barddhaman", "Bareilly", "Bargarh", "Barhaj",
    "Bari Sadri", "Barjora", "Baroli", "Barwani", "Basaha", "Basantpur", "Basawan",
    "Bastar", "Basth", "Batauli", "Bate", "Baten", "Bate", "Baten", "Bater", "Bates",
    "Batesa", "Batesahi", "Batespur", "Batesar", "Batesar", "Batespur", "Bateshwar",
    "Bateslabad", "Batespur", "Batessa", "Batessa", "Batessa", "Batessar", "Batessa",
    "Batessar", "Batessa", "Batessar", "Batessa", "Batessar", "Batessa"
  ],
  "Uttarakhand": [
    "Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Garhwal", "Haridwar",
    "Kumaon", "Nainital", "Pauri", "Pithoragarh", "Rudraprayag", "Tehri", "Udham Singh Nagar",
    "Uttarkashi"
  ],
  "West Bengal": [
    "Alipurduar", "Arambagh", "Asansol", "Bally", "Balurghat", "Bankura", "Barasat",
    "Barendrapalli", "Bargarh", "Barjora", "Baroli", "Barwan", "Barisal", "Basirhat",
    "Baspatna", "Basta", "Batala", "Batespur", "Bathinda", "Bauli", "Baulkapur", "Baur",
    "Baur", "Baurla", "Bauria", "Baurli", "Baurpur", "Baursa", "Baursapur", "Baurspur",
    "Baur", "Baurwa", "Baurwari", "Baurwat", "Baushpur", "Bausi", "Bausia", "Bausini",
    "Bausir", "Bauskandi", "Bauspur", "Bauspuri", "Bauspurpur", "Baussa", "Baussai",
    "Baussapur", "Bausspur", "Baussur", "Baussuri", "Baussurpur", "Baussut", "Baussuti",
    "Baussutpur", "Bausswar", "Bauswari", "Bausswar", "Bausswar"
  ]
};

export const INDIAN_STATES = Object.keys(INDIAN_STATES_DISTRICTS).sort();

export function getDistrictsForState(state) {
  return INDIAN_STATES_DISTRICTS[state] || [];
}
